export { default } from './PageSeoConfigs.vue'
